'use client';

import { ReactNode, Ref, forwardRef, useEffect, useRef, useState } from "react";
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { twMerge } from 'tailwind-merge';
import HomeArrow from './svg/HomeArrow';

interface Props {
  slides: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  swiperProps?: Partial<SwiperProps>;
  swiperSlideProps?: Partial<SwiperSlideProps>;
  setSelected: (idx: number) => void;
  selected?: number;
  itemsLength: number;
  id: string;
}

const Swiper = forwardRef(({ slides, className, wrapperClassName, swiperProps, swiperSlideProps, setSelected, selected, itemsLength, id }: Props, ref: any) => {
    // const [init, setInit] = useState(false);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
  return (
    <>
    <div className={twMerge('flex flex-col w-full min-h-[90px] desktop:px-0 gap-y-[48px] desktop:gap-y-0', wrapperClassName)} key={id}>
      <SwiperJS
         loop
        dir='rtl'
        breakpoints={{
          0: {
            slidesPerView: 1.1,
            centeredSlides: false
          },
          768: {
            slidesPerView: 'auto',
            centeredSlides: false
          },
          1024: {
            slidesPerView: 'auto',
            centeredSlides: false,
          },

        }}
          pagination={
          {
            dynamicBullets: true,
            dynamicMainBullets: 1,
            el: `.swiper-custom-pagination-${id}`,
            type: 'bullets',
            clickable: true,
            // bulletActiveClass: 'bg-secondary',
            bulletClass: `swiper-pagination-bullet-${id}`,
          }
        }
        onSlideChange={() => {
          const swiper = ref.current?.swiper;
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onInit={() => {
          const swiper = ref.current?.swiper;
          if (swiper) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            // swiper.autoplay.stop();
            // setTimeout(() => swiper.autoplay?.start(), 6000)
          }
          // setInit(true);
        }}
        // speed={1750}  
        modules={[Pagination]}
        uniqueNavElements={false}
        // autoplay={{
        //   delay: 2000
        // }}
        {...swiperProps}

        className={twMerge('w-full !relative h-[90px] flex-shrink-0', swiperProps?.className)}
        wrapperClass={twMerge(className)}
        ref={ref}
      >
        {slides.map((s, i) => <SwiperSlide key={i} {...swiperSlideProps} className={twMerge('px-0 tablet:px-0 tablet:pl-[24px] tablet:last:pl-0 h-full', swiperSlideProps?.className)}>{s}</SwiperSlide>)}
      </SwiperJS>
      <div className={`!h-[25px] !w-full !flex !items-center [&>*]:!scale-100 [&>*]:opacity-50 [&>.swiper-pagination-bullet-active]:!opacity-100 [&>.swiper-pagination-bullet-active]:!bg-primary [&>.swiper-pagination-bullet-active]:!h-[12px] [&>.swiper-pagination-bullet-active]:!w-[12px] !justify-center [&>*]:!bg-gray-400 dark:[&>*]:!bg-white [&>*]:!h-[6px] [&>*]:!w-[6px] [&>*]:aspect-square gap-x-[24px] [&>*]:rounded-full swiper-custom-pagination-${id} desktop:!hidden`}></div> 
      <div 
  onClick={() => {
    if (isEnd) return;
    ref.current?.swiper?.slideNext();
    let newIndex = selected! + 1;
    if (newIndex >= itemsLength) {
      newIndex = 0;
    }
    setSelected(newIndex);
  }}
  className={twMerge(
    'absolute left-0 desktop:left-[-50px] top-[-250px] desktop:top-[-300px] desktopSm:!left-0 h-[72px] w-fit grid place-items-center cursor-pointer',
    isEnd && '!hidden'
  )}
>
  <HomeArrow className='h-[72px] w-[72px]'/>
</div>

<div 
  onClick={() => {
    if (isBeginning) return;
    ref.current?.swiper?.slidePrev();
    setSelected((selected || 1) - 1)
  }}
  className={twMerge(
    'absolute top-[-250px] desktop:top-[-300px] right-0 desktop:right-[-50px] desktopSm:!right-0 h-[72px] w-fit grid place-items-center cursor-pointer rotate-180',
    isBeginning && '!hidden'
  )}
>
  <HomeArrow className='h-[72px] w-[72px]'/>
</div>
  </div>
 </>

)
});


export default Swiper;